import React, { useState, useEffect, useRef } from 'react';
import {
  Tooltip,
  Column,
  Checkbox,
  DataTable,
  PrimeIcons,
  Skeleton,
  Button,
  Toast,
  Dropdown,
} from 'primereact';
import {separarPorMayuscula} from "../../../Commons/Scripts/Utils/formatear";

export const OtrosPermisosButton = ({ permisos, checkList, setCheckList }) => {
  const [showOptions, setShowOptions] = useState(false);
  const componentRef = useRef(null);
  const randomNumber = Math.floor(Math.random() * 10000);

  const handleClickOutside = (event) => {
    if (
      componentRef.current &&
      !componentRef.current.contains(event.target) &&
      event.target.closest(`.accion-rapida-${randomNumber}`) === null &&
      !event.target.classList.contains("custom-checkbox-input")
    ) {
      setShowOptions(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div ref={componentRef} style={{ position: "relative" }}>
      <div
        style={{
          position: "relative",
          cursor: "pointer",
          marginLeft: "10px",
        }}
        id="accion-rapida"
        onClick={() => setShowOptions((prevValue) => !prevValue)}
      >
        <span className="pi pi-ellipsis-h otros-permisos-button"></span>
      </div>
      {showOptions && (
        <div
          className={`accion-rapida-${randomNumber} otros-permisos`}
          style={{
            right: "95%",
            top: "-10%",
          }}
        >
          {permisos.map((p) => {
            return (
              <div
                className="option"
                key={p.FuncionId}
                style={{
                  borderRadius: "5px",
                  gap: "10px",
                  display: "flex",
                  alignItems: "center",
                  alignContent: "center",
                  justifyContent: "space-between",
                  padding: "10px",
                }}
              >
                <div
                  style={{ display: "flex", gap: "10px", marginRight: "15px" }}
                >
                  <Checkbox
                    className="custom-checkbox-input"
                    onClick={(e) => e.stopPropagation()}
                    name={p?.Nombre}
                    checked={checkList.some((t) => t === p.IdSec) ?? false}
                    onChange={(e) => {
                      if (checkList.some((f) => f === p.IdSec)) {
                        setCheckList((prev) =>
                          prev.filter((f) => f !== p.IdSec)
                        );
                      } else {
                        setCheckList((prev) => [...prev, p.IdSec]);
                      }
                    }}
                  />
                  <p
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                      margin: "0px",
                    }}
                  >
                    {separarPorMayuscula(p?.FuncionCompleta)}
                  </p>
                </div>
                <div>
                  <Tooltip target=".custom-target-icon" />
                  <i
                    className={`custom-target-icon ${PrimeIcons.INFO_CIRCLE} info-icon`}
                    data-pr-tooltip={`${p?.Descripcion}`}
                    data-pr-position="top"
                  ></i>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
